import React from "react";
import websiteData from '../data.json';
/* Import Components */
import CoverHeaderButton from '../components/header/cover-header-button';
import FeatureContainer from '../components/containers/feature-container';
import FeatureSectionContainer from '../components/containers/featuresection-container';
import Feature3Container from '../components/containers/feature3-container';
import ReactGA from 'react-ga';

export const initGA = () => {
    /* console.log('Ga init'); */
    ReactGA.initialize('UA-90162173-1');
}

export const logPageView = () => {
    /* console.log(window.location.pathname); */
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}


export default class PageBody extends React.Component {
    constructor(props) {
        super(props);
        //var randomImage = websiteData.homePage.CoverHeaderButton.headerBackgroundImages[ Math.floor(Math.random() * websiteData.homePage.CoverHeaderButton.headerBackgroundImages.length) ];
        this.state = {
            image : ''
        };
    }
    componentDidMount() {
    
        var randomImage = websiteData.homePage.CoverHeaderButton.headerBackgroundImages[ Math.floor(Math.random() * websiteData.homePage.CoverHeaderButton.headerBackgroundImages.length) ];
        this.setState((prevState, props) => {
            return {image: randomImage};
        });
    
    
        initGA();
        logPageView();
    } 
    render() {
        const homePage = websiteData.homePage,
              dataCoverHeaderButton = homePage.CoverHeaderButton,
              dataFeature3Container = homePage.Feature3Container,
              dataFeatureContainer = homePage.FeatureContainer,
              dataFeatureSectionContainer = homePage.FeatureSectionContainer;  
              //console.log('chosen image: '+this.state.image) 
              //console.log('how many times does it render?')
        return (
            <div id="page">
                <CoverHeaderButton backgroundImages={ this.state.image } headerTitle={ dataCoverHeaderButton.headerTitle } headerSubTitle={ dataCoverHeaderButton.headerSubTitle } buttonName={ dataCoverHeaderButton.buttonName } buttonTo={ dataCoverHeaderButton.buttonTo } buttonClass={ dataCoverHeaderButton.buttonClass }/>
                <Feature3Container feature3Items={ dataFeature3Container.boxItemDetailsTeamServicesJobs } />
                <FeatureContainer titleContent={ { title: dataFeatureContainer.h2TitleParagraphFirst.title, paragraph: dataFeatureContainer.h2TitleParagraphFirst.paragraph } } featureItems={ dataFeatureContainer.boxItemDetailsTechnicalPragmaticPersonal }/>
                <FeatureSectionContainer titleContent={ { title: dataFeatureSectionContainer.h2TitleParagraphSecond.title, paragraph: dataFeatureSectionContainer.h2TitleParagraphSecond.paragraph } } featureSectionItems={ dataFeatureSectionContainer.bttsdTeam }/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/home-page.js